/* KULN × LIKE ME · storefront script. Built from the 3 Oct 2026 study by build_shopify.py; edit the study, not this file. */
var LMRE = /^\/(?!checkout|account|cdn|admin|policies)/;
function LMA(n) { return (window.LM && window.LM.a && window.LM.a[n]) || ("assets/" + n); }
/* KULN store pages study · shared behaviour. Native, no deps. Review only: the
   "bag" is a local counter so the flow can be felt; nothing is transacted. */
(function () {
  var html = document.documentElement;
  var mq = window.matchMedia("(prefers-reduced-motion: reduce)");
  var reduced = mq.matches;
  var motionBtn = document.getElementById("motion-toggle");
  function applyMotion() {
    html.classList.toggle("reduced", reduced);
    if (motionBtn) { motionBtn.setAttribute("aria-pressed", String(!reduced)); motionBtn.textContent = "Motion: " + (reduced ? "off" : "on"); }
    drawDissolve(true); revealAll();
  }
  if (motionBtn) motionBtn.addEventListener("click", function () { reduced = !reduced; applyMotion(); });
  if (mq.addEventListener) mq.addEventListener("change", function (e) { reduced = e.matches; applyMotion(); });

  /* menu */
  var menuBtn = document.getElementById("menu-btn"), nav = document.getElementById("site-nav");
  if (menuBtn && nav) menuBtn.addEventListener("click", function () {
    var open = nav.classList.toggle("open"); menuBtn.setAttribute("aria-expanded", String(open));
  });

  /* bag counter (review-only) */
  var KEY = "kuln-study-bag";
  function bag() { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch (e) { return []; } }
  function setBag(b) { try { localStorage.setItem(KEY, JSON.stringify(b)); } catch (e) {} paintBag(); }
  function paintBag() {
    var n = bag().reduce(function (s, l) { return s + l.qty; }, 0);
    Array.prototype.forEach.call(document.querySelectorAll("[data-bag-count]"), function (el) { el.textContent = n; });
  }
  window.kulnBag = { get: bag, set: setBag };
  paintBag();

  /* quick add from record cards */
  Array.prototype.forEach.call(document.querySelectorAll("[data-add]"), function (btn) {
    btn.addEventListener("click", function () {
      var d = btn.dataset, b = bag();
      var size = d.size || (document.querySelector('input[name="size"]:checked') || {}).value || "";
      var q = parseInt((document.getElementById("qty") || {}).value || "1", 10) || 1;
      if (btn.hasAttribute("data-needs-size") && !size) {
        var f = document.getElementById("size-field"); if (f) { f.classList.add("nudge"); f.scrollIntoView({ block: "center" }); }
        var hint = document.getElementById("size-hint"); if (hint) hint.textContent = "Pick a size first.";
        return;
      }
      var found = b.filter(function (l) { return l.id === d.add && l.size === size; })[0];
      if (found) found.qty += q; else b.push({ id: d.add, name: d.name, size: size, price: +d.price, img: d.img, qty: q });
      window.kulnBag.set(b);
      var old = btn.textContent; btn.textContent = "Added ✓"; btn.disabled = true;
      setTimeout(function () { btn.textContent = old; btn.disabled = false; }, 1100);
    });
  });

  /* filter rail */
  var rail = document.querySelector(".rail");
  if (rail) rail.addEventListener("click", function (e) {
    var b = e.target.closest("button"); if (!b) return;
    Array.prototype.forEach.call(rail.querySelectorAll("button"), function (x) { x.setAttribute("aria-pressed", String(x === b)); });
    var f = b.dataset.filter, n = 0;
    Array.prototype.forEach.call(document.querySelectorAll(".rec"), function (r) {
      var show = f === "all" || r.dataset.set === f; r.hidden = !show; if (show) n++;
    });
    var c = document.getElementById("rec-count"); if (c) c.textContent = n + " records";
  });

  /* qty stepper */
  var qty = document.getElementById("qty");
  if (qty) Array.prototype.forEach.call(document.querySelectorAll("[data-step]"), function (b) {
    b.addEventListener("click", function () { qty.value = Math.max(1, Math.min(5, (+qty.value || 1) + (+b.dataset.step))); });
  });
  /* size hint */
  Array.prototype.forEach.call(document.querySelectorAll('input[name="size"]'), function (r) {
    r.addEventListener("change", function () { var h = document.getElementById("size-hint"); if (h) h.textContent = "Size " + r.value + " selected"; });
  });

  /* reveal */
  var io = ("IntersectionObserver" in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } });
  }, { rootMargin: "0px 0px -8% 0px" }) : null;
  function revealAll() {
    Array.prototype.forEach.call(document.querySelectorAll(".reveal"), function (el) {
      if (reduced || !io) el.classList.add("in"); else io.observe(el);
    });
  }

  /* ---------- dissolve: LIKE ME as particles, dispersed by scroll (Study 01 motif) ---------- */
  function prng(seed) { var s = seed % 2147483647; if (s <= 0) s += 2147483646; return function () { s = (s * 16807) % 2147483647; return s / 2147483647; }; }
  var cv = document.getElementById("dissolve"), ctx = cv ? cv.getContext("2d") : null, particles = [];
  var dpr = Math.min(window.devicePixelRatio || 1, 2);
  function buildParticles() {
    if (!cv || !ctx) return;
    var w = cv.clientWidth, h = cv.clientHeight; if (w < 4 || h < 4) return;
    cv.width = w * dpr; cv.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var off = document.createElement("canvas"); off.width = w; off.height = h; var o = off.getContext("2d");
    if (cv.dataset.src) {
      /* the official wordmark, drawn from its file, instead of typed letters */
      if (!buildParticles.img) { var im = new Image(); im.onload = function () { buildParticles.img = im; buildParticles(); }; im.src = cv.dataset.src; return; }
      var iw = Math.min(w * 0.62, 760), ih = iw * buildParticles.img.height / buildParticles.img.width;
      o.drawImage(buildParticles.img, (w - iw) / 2, h * 0.62 - ih / 2, iw, ih);
    } else {
      o.fillStyle = "#000"; o.font = "900 " + Math.min(w / 4.6, h * 0.62) + 'px "Helvetica Neue", Helvetica, Arial, sans-serif';
      o.textAlign = "center"; o.textBaseline = "middle"; o.fillText(cv.dataset.word || "LIKE ME", w / 2, h * 0.55);
    }
    var data = o.getImageData(0, 0, w, h).data, rnd = prng(29); particles = [];
    var step = cv.dataset.src ? 2 : (w > 700 ? 3 : 2);
    for (var y = 0; y < h; y += step) for (var x = 0; x < w; x += step)
      if (data[(y * w + x) * 4 + 3] > 128) particles.push({ x: x, y: y, a: rnd() * Math.PI * 2, v: 30 + rnd() * 170, r: rnd() });
    drawDissolve(true);
  }
  function drawDissolve(force) {
    if (!cv || !ctx || !particles.length) return;
    var w = cv.clientWidth, h = cv.clientHeight, p;
    if (reduced) p = cv.dataset.src ? 0 : 0.32;
    else { var rect = cv.getBoundingClientRect(); p = 1 - (rect.top + rect.height * 0.6) / (window.innerHeight + rect.height); p = Math.min(1, Math.max(0, p)) * 1.15; if (cv.dataset.src) p = Math.max(0, (p - 0.45) / 0.55); }
    if (!force && p === drawDissolve._last) return; drawDissolve._last = p;
    ctx.clearRect(0, 0, w, h); ctx.fillStyle = "#0a0a0a";
    for (var i = 0; i < particles.length; i++) {
      var pt = particles[i], gate = pt.r * 0.6, lift = p <= gate ? 0 : Math.min(1, (p - gate) / (1 - gate));
      var dx = Math.cos(pt.a) * pt.v * lift, dy = -Math.abs(Math.sin(pt.a)) * pt.v * lift * 1.6 - lift * 90 * pt.r;
      ctx.globalAlpha = 1 - lift * 0.85; ctx.fillRect(pt.x + dx, pt.y + dy, 2, 2);
    }
    ctx.globalAlpha = 1;
  }
  /* ---------- v7 motion: trailing copies, smeared heading, mark made of copies ---------- */
  var ghost = document.getElementById("ghostmark");
  var smears = Array.prototype.slice.call(document.querySelectorAll("[data-smear]"));
  smears.forEach(function (el) {
    var label = el.textContent;
    for (var i = 6; i >= 1; i--) { var l = document.createElement("span"); l.className = "layer"; l.style.filter = "blur(" + (i * 0.9).toFixed(1) + "px)"; l.setAttribute("aria-hidden", "true"); l.textContent = label; l.dataset.i = i; el.insertBefore(l, el.firstChild); }
  });
  var copies = document.querySelector(".copies-text");
  if (copies) copies.textContent = new Array(4500).join("me ");
  function v7Motion() {
    if (ghost) {
      /* crisp while the logo sits in view; the copies trail only as it leaves through the top */
      var gr = ghost.getBoundingClientRect(), edge = Math.max(40, Math.min(window.innerHeight * 0.3, gr.top + window.scrollY - 70));
      ghost.style.setProperty("--lag", reduced ? 0 : Math.min(3, Math.max(0, (edge - gr.top) / edge) * 3).toFixed(3));
    }
    smears.forEach(function (el) {
      var r = el.getBoundingClientRect(), vh = window.innerHeight;
      var t = reduced ? 0 : Math.min(1, Math.max(0, (r.top - vh * 0.45) / (vh * 0.5)));
      Array.prototype.forEach.call(el.querySelectorAll(".layer"), function (l) {
        var i = +l.dataset.i;
        l.style.transform = "translate3d(" + (i * 0.1 * t).toFixed(3) + "em,0,0)";
        l.style.opacity = t === 0 ? 0 : Math.max(0.03, 0.42 - i * 0.04).toFixed(2);
      });
    });
  }
  if (ghost && !reduced) { ghost.style.setProperty("--lag", 4); setTimeout(v7Motion, 250); } else v7Motion();
  if (motionBtn) motionBtn.addEventListener("click", function () { setTimeout(v7Motion, 0); });

  var ticking = false;
  window.addEventListener("scroll", function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { if (!reduced) drawDissolve(false); v7Motion(); ticking = false; }); } }, { passive: true });
  var rt; window.addEventListener("resize", function () { clearTimeout(rt); rt = setTimeout(buildParticles, 120); });
  buildParticles(); applyMotion();
})();

/* ---------- v8 · bag page and the signature moves (page wipe, hover strips, cursor label,
   photo zoom, live copies, logo assembling, added-to-bag notice). All off when Motion is off. ---------- */
(function () {
  var html = document.documentElement;
  function reduced() { return html.classList.contains("reduced"); }
  var fine = window.matchMedia && window.matchMedia("(hover:hover) and (pointer:fine)").matches;
  function peso(n) { return "₱" + Math.round(n).toLocaleString("en-US"); }
  function each(sel, fn, root) { Array.prototype.forEach.call((root || document).querySelectorAll(sel), fn); }

  /* page change */
  function wipe(cls) {
    var w = document.createElement("div"); w.className = "wipe " + cls; w.setAttribute("aria-hidden", "true");
    for (var i = 0; i < 7; i++) { var b = document.createElement("i"); b.style.setProperty("--i", i); w.appendChild(b); }
    document.body.appendChild(w); return w;
  }
  var arriving = false; try { arriving = sessionStorage.getItem("kuln-wipe") === "1"; sessionStorage.removeItem("kuln-wipe"); } catch (e) {}
  if (arriving && !reduced()) { var wo = wipe("out"); setTimeout(function () { wo.remove(); }, 700); }
  document.addEventListener("click", function (e) {
    var a = e.target.closest ? e.target.closest("a[href]") : null; if (!a) return;
    var h = a.getAttribute("href");
    if (!LMRE.test(h) || e.metaKey || e.ctrlKey || e.shiftKey || a.target || reduced()) return;
    e.preventDefault(); try { sessionStorage.setItem("kuln-wipe", "1"); } catch (err) {}
    wipe("in"); setTimeout(function () { window.location.href = h; }, 190);
  });
  window.addEventListener("pageshow", function (e) { if (e.persisted) each(".wipe", function (w) { w.remove(); }); });

  /* product shots: on hover three strips of the photo jump sideways and settle.
     The strips exist only for that half second, so idle cards carry no extra layers. */
  each(".piece:not(.tbc) .shot", function (shot) {
    var img = shot.querySelector("img"), busy = false; if (!img) return;
    shot.addEventListener("mouseenter", function () {
      if (reduced() || busy) return; busy = true;
      var made = ["s1", "s2", "s3"].map(function (c) { var k = img.cloneNode(false); k.className = "slice " + c; k.alt = ""; k.removeAttribute("loading"); k.setAttribute("aria-hidden", "true"); shot.appendChild(k); return k; });
      shot.classList.add("glitch");
      setTimeout(function () { shot.classList.remove("glitch"); made.forEach(function (k) { k.remove(); }); busy = false; }, 400);
    });
  });

  /* product shots lean toward the pointer: followed frame by frame, so it never trails */
  if (fine) each(".piece:not(.tbc) .shot", function (shot) {
    var tx = 0, ty = 0, x = 0, y = 0, raf = 0, inside = false;
    var step = function () {
      x += (tx - x) * 0.22; y += (ty - y) * 0.22;
      if (!inside && Math.abs(x) < 0.02 && Math.abs(y) < 0.02) { raf = 0; shot.style.transform = ""; shot.style.willChange = ""; return; }
      shot.style.transform = "perspective(900px) rotateY(" + x.toFixed(2) + "deg) rotateX(" + y.toFixed(2) + "deg)";
      raf = requestAnimationFrame(step);
    };
    shot.addEventListener("mousemove", function (e) {
      if (reduced()) return; var r = shot.getBoundingClientRect();
      tx = ((e.clientX - r.left) / r.width - 0.5) * 8; ty = -((e.clientY - r.top) / r.height - 0.5) * 7;
      inside = true; if (!raf) { shot.style.willChange = "transform"; raf = requestAnimationFrame(step); }
    }, { passive: true });
    shot.addEventListener("mouseleave", function () { inside = false; tx = ty = 0; if (!raf) raf = requestAnimationFrame(step); });
  });

  /* product page: thumbnails swap the main photo */
  each(".thumbs7 button", function (b) {
    b.addEventListener("click", function () {
      var m = document.querySelector(".gallery7 .main img"); if (!m) return;
      m.srcset = b.dataset.small + " 640w, " + b.dataset.full + " 1200w"; m.src = b.dataset.full;
      each(".thumbs7 button", function (o) { o.removeAttribute("aria-current"); }); b.setAttribute("aria-current", "true");
    });
  });

  /* product page zoom */
  each(".gallery7 .main", function (fig) {
    var img = fig.querySelector("img"); if (!img || !fine) return;
    fig.addEventListener("mousemove", function (e) { var r = fig.getBoundingClientRect(); img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100).toFixed(1) + "% " + ((e.clientY - r.top) / r.height * 100).toFixed(1) + "%"; });
    fig.addEventListener("mouseenter", function () { if (!reduced()) fig.classList.add("zoom"); });
    fig.addEventListener("mouseleave", function () { fig.classList.remove("zoom"); });
  });

  /* hero logo assembles from particles on load (home only) */
  var gm = document.querySelector(".hero3 .ghostmark"), gimg = gm ? gm.querySelector(".o") : null;
  if (gm && gimg && !reduced() && !arriving) {
    gm.classList.add("building");
    var start = function () {
      var cv = document.createElement("canvas"); cv.className = "assemble"; gm.appendChild(cv);
      var d = Math.min(window.devicePixelRatio || 1, 2), W = cv.clientWidth, H = cv.clientHeight; if (W < 10) { gm.classList.remove("building"); cv.remove(); return; }
      cv.width = W * d; cv.height = H * d; var c = cv.getContext("2d"); c.setTransform(d, 0, 0, d, 0, 0);
      var bw = gm.clientWidth, bh = gm.clientHeight, ox = (W - bw) / 2, oy = (H - bh) / 2;
      var off = document.createElement("canvas"); off.width = bw; off.height = bh; var o = off.getContext("2d"); o.drawImage(gimg, 0, 0, bw, bh);
      var data; try { data = o.getImageData(0, 0, bw, bh).data; } catch (err) { gm.classList.remove("building"); cv.remove(); return; }
      var pts = [], s = 7; function rnd() { s = (s * 16807) % 2147483647; return s / 2147483647; }
      for (var y = 0; y < bh; y += 2) for (var x = 0; x < bw; x += 2) if (data[(y * bw + x) * 4 + 3] > 120) pts.push({ x: x, y: y, a: rnd() * Math.PI * 2, v: 40 + rnd() * 220, r: rnd() });
      var t0 = null, dur = 900;
      function frame(t) {
        if (t0 === null) t0 = t; var k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3);
        c.clearRect(0, 0, W, H); c.fillStyle = "#000";
        for (var i = 0; i < pts.length; i++) {
          var p = pts[i], lift = Math.max(0, 1 - e / (0.45 + p.r * 0.55));
          c.globalAlpha = 1 - lift * 0.8;
          c.fillRect(ox + p.x + Math.cos(p.a) * p.v * lift, oy + p.y - Math.abs(Math.sin(p.a)) * p.v * lift * 1.5 - lift * 60 * p.r, 2, 2);
        }
        if (k < 1) requestAnimationFrame(frame); else { gm.classList.remove("building"); setTimeout(function () { cv.remove(); }, 260); }
      }
      requestAnimationFrame(frame);
    };
    if (gimg.complete && gimg.naturalWidth) start(); else { gimg.addEventListener("load", start); gimg.addEventListener("error", function () { gm.classList.remove("building"); }); }
    setTimeout(function () { gm.classList.remove("building"); }, 3200);
  }

  /* added-to-bag notice + count bump */
  var bagApi = window.kulnBag;
  if (bagApi) {
    var toast = document.createElement("div"); toast.className = "toast7"; toast.setAttribute("role", "status");
    toast.innerHTML = '<span>Added to bag</span><a href="bag.html">View bag</a>'; document.body.appendChild(toast);
    var tt, origSet = bagApi.set, count = function (b) { return b.reduce(function (n, l) { return n + l.qty; }, 0); };
    bagApi.set = function (b) {
      var before = count(bagApi.get()); origSet(b);
      each("[data-bag-count]", function (el) { el.classList.remove("bump"); void el.offsetWidth; el.classList.add("bump"); });
      if (count(b) > before && !document.getElementById("bag-root")) { toast.classList.add("on"); clearTimeout(tt); tt = setTimeout(function () { toast.classList.remove("on"); }, 3200); }
    };
  }

  /* bag page */
  var root = document.getElementById("bag-root");
  if (root && bagApi) {
    var list = document.getElementById("bag-lines"), empty = document.getElementById("bag-empty"), shown = { sub: 0 };
    var roll = function (el, to) {
      var from = shown.sub, t0 = null; if (reduced()) { el.forEach(function (x) { x.textContent = peso(to); }); shown.sub = to; return; }
      (function step(t) { if (t0 === null) t0 = t; var k = Math.min(1, (t - t0) / 420), v = from + (to - from) * (1 - Math.pow(1 - k, 3)); el.forEach(function (x) { x.textContent = peso(v); }); if (k < 1) requestAnimationFrame(step); else shown.sub = to; })(performance.now());
    };
    var totals = function () {
      var b = bagApi.get(), n = b.reduce(function (s, l) { return s + l.qty; }, 0), sub = b.reduce(function (s, l) { return s + l.qty * l.price; }, 0);
      root.hidden = !b.length; empty.hidden = !!b.length;
      document.getElementById("bag-count-line").textContent = n ? n + (n === 1 ? " piece" : " pieces") : "";
      roll([document.getElementById("bag-sub"), document.getElementById("bag-total")], sub);
    };
    var render = function () {
      list.innerHTML = "";
      bagApi.get().forEach(function (l, i) {
        var slug = String(l.id).replace("likeme-", ""), li = document.createElement("li"); li.className = "line7";
        li.innerHTML = '<a class="thumb" href="product-' + slug + '.html"><img src="' + l.img + '" alt=""></a>' +
          '<div class="what"><h2><a href="product-' + slug + '.html"></a></h2><span class="meta"></span>' +
          '<div class="tools"><div class="qty7"><button type="button" data-d="-1" aria-label="One less">−</button><output></output><button type="button" data-d="1" aria-label="One more">+</button></div><button type="button" class="rm">Remove</button></div></div>' +
          '<span class="lt num"></span>';
        li.querySelector("h2 a").textContent = l.name;
        li.querySelector(".meta").textContent = (l.size && l.size !== "OS" ? "Size " + l.size : "One size") + " · " + peso(l.price);
        var out = li.querySelector("output"), lt = li.querySelector(".lt"); out.textContent = l.qty; lt.textContent = peso(l.qty * l.price);
        each("[data-d]", function (btn) { btn.addEventListener("click", function () {
          var b = bagApi.get(), line = b[i]; if (!line) return; line.qty = Math.max(1, Math.min(5, line.qty + (+btn.dataset.d)));
          bagApi.set(b); out.textContent = line.qty; lt.textContent = peso(line.qty * line.price); totals();
        }); }, li);
        li.querySelector(".rm").addEventListener("click", function () {
          li.style.maxHeight = li.offsetHeight + "px"; void li.offsetWidth; li.classList.add("gone");
          var b = bagApi.get(); b.splice(i, 1); bagApi.set(b); totals();
          setTimeout(render, reduced() ? 0 : 460);
        });
        list.appendChild(li);
      });
      totals();
    };
    render();
  }
})();

/* ---------- v9 · pushed harder: particle logo that reacts to the pointer, the ticker, tilt, scrambled titles,
   pulling buttons, hero strips, rising slogan, scroll hairline. Loops run only while their section is on screen. ---------- */
(function () {
  var html = document.documentElement;
  function reduced() { return html.classList.contains("reduced"); }
  var fine = window.matchMedia && window.matchMedia("(hover:hover) and (pointer:fine)").matches;
  function each(sel, fn, root) { Array.prototype.forEach.call((root || document).querySelectorAll(sel), fn); }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function watch(el, fn) { if (!("IntersectionObserver" in window)) { fn(true); return; } new IntersectionObserver(function (es) { fn(es[0].isIntersecting); }, { rootMargin: "120px 0px" }).observe(el); }

  /* scroll speed, shared */
  var lastY = window.scrollY, vel = 0;
  var prog = document.createElement("div"); prog.className = "prog7"; prog.setAttribute("aria-hidden", "true"); document.body.appendChild(prog);
  window.addEventListener("scroll", function () {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    prog.style.transform = "scaleX(" + (max > 0 ? clamp(window.scrollY / max, 0, 1) : 0).toFixed(4) + ")";
  }, { passive: true });

  /* particle logo */
  var pc = document.getElementById("plogo");
  if (pc && pc.getContext) {
    var c = pc.getContext("2d"), pts = [], pw = 0, ph = 0, step = 3, img = new Image(), mx = -9999, my = -9999, on = false, raf = 0;
    var build = function () {
      pw = pc.clientWidth; ph = pc.clientHeight; if (pw < 10 || !img.naturalWidth) return;
      var d = Math.min(window.devicePixelRatio || 1, 2); pc.width = pw * d; pc.height = ph * d; c.setTransform(d, 0, 0, d, 0, 0);
      var iw = Math.round(Math.min(pw * 0.86, 1180)), ih = Math.round(iw * img.naturalHeight / img.naturalWidth);
      var off = document.createElement("canvas"); off.width = iw; off.height = ih; var o = off.getContext("2d"); o.drawImage(img, 0, 0, iw, ih);
      var data; try { data = o.getImageData(0, 0, iw, ih).data; } catch (e) { return; }
      step = iw > 760 ? 3 : 2; pts = []; var ox = (pw - iw) / 2, oy = ph * 0.56 - ih / 2, s = 29;
      function rnd() { s = (s * 16807) % 2147483647; return s / 2147483647; }
      for (var y = 0; y < ih; y += step) for (var x = 0; x < iw; x += step) if (data[(y * iw + x) * 4 + 3] > 120) pts.push({ hx: ox + x, hy: oy + y, x: ox + x, y: oy + y, a: rnd() * Math.PI * 2, v: 60 + rnd() * 260, r: rnd() });
    };
    var tick = function () {
      raf = 0; if (!on) return;
      var r = pc.getBoundingClientRect(), p = 1 - (r.top + r.height * 0.6) / (window.innerHeight + r.height);
      p = reduced() ? 0 : Math.max(0, (clamp(p, 0, 1) * 1.15 - 0.5) / 0.5);
      var lx = mx - r.left, ly = my - r.top, R = 120, R2 = R * R, still = true;
      c.clearRect(0, 0, pw, ph); c.fillStyle = "#0a0a0a";
      for (var i = 0; i < pts.length; i++) {
        var q = pts[i], gate = q.r * 0.6, lift = p <= gate ? 0 : Math.min(1, (p - gate) / (1 - gate));
        var tx = q.hx + Math.cos(q.a) * q.v * lift, ty = q.hy - Math.abs(Math.sin(q.a)) * q.v * lift * 1.6 - lift * 90 * q.r;
        var dx = q.x - lx, dy = q.y - ly, d2 = dx * dx + dy * dy;
        if (d2 < R2 && !reduced()) { var d = Math.sqrt(d2) || 1, f = 1 - d / R; tx += dx / d * f * f * 110; ty += dy / d * f * f * 110; }
        var ex = tx - q.x, ey = ty - q.y; if (ex * ex + ey * ey > 0.05) still = false;
        q.x += ex * 0.14; q.y += ey * 0.14;
        if (lift > 0) { c.globalAlpha = 1 - lift * 0.85; c.fillRect(q.x, q.y, step, step); c.globalAlpha = 1; } else c.fillRect(q.x, q.y, step, step);
      }
      if (!still || lift0 !== p) { lift0 = p; raf = requestAnimationFrame(tick); } else lift0 = p;
    };
    var lift0 = -1, kick = function () { if (on && !raf) raf = requestAnimationFrame(tick); };
    img.crossOrigin = "anonymous"; img.onload = function () { build(); kick(); }; img.src = pc.dataset.src;
    watch(pc, function (v) { on = v; kick(); });
    window.addEventListener("scroll", kick, { passive: true });
    window.addEventListener("mousemove", function (e) { mx = e.clientX; my = e.clientY; kick(); }, { passive: true });
    window.addEventListener("touchmove", function (e) { var t = e.touches[0]; if (t) { mx = t.clientX; my = t.clientY; kick(); } }, { passive: true });
    pc.addEventListener("mouseleave", function () { mx = my = -9999; kick(); });
    window.addEventListener("touchend", function () { mx = my = -9999; kick(); });
    var rt; window.addEventListener("resize", function () { clearTimeout(rt); rt = setTimeout(function () { build(); kick(); }, 150); });
  }

  /* the band: facts drift at a steady 22px a second. Time based, transform only, paused off screen and under the pointer; still when motion is off. */
  var track = document.getElementById("ticker");
  if (track) {
    var facts = [
      ["Pre-order 4 Oct, 12:00 noon to 8 Oct, 11:59 PM, Philippine time", true],
      ["Ships 30 to 45 days after the window closes"],
      ["Manila, PH"],
      ["Local and international delivery"],
      ["Cropped boxy tee <b>\u20b12,049</b>"],
      ["Cap <b>\u20b11,599</b>"],
      ["Socks <b>\u20b1549</b>"],
      ["The Complete Set <b>\u20b15,299</b>"]
    ];
    var unit = '<span class="unit">' + facts.map(function (f) { return (f[1] ? '<i class="live"></i>' : "") + '<span class="f">' + f[0] + '</span><i class="sep"></i>'; }).join("") + "</span>";
    track.innerHTML = unit + unit + unit;
    var tx = 0, setW = 0, ton = false, traf = 0, tlast = 0, tspeed = 22, thover = false;
    var measure = function () { var u = track.firstElementChild; setW = u ? u.offsetWidth : 0; };
    var run = function (now) {
      traf = 0; if (!ton || reduced()) { tlast = 0; return; }
      if (!setW) measure();
      var dt = tlast ? Math.min(64, now - tlast) : 16; tlast = now;
      tspeed += ((thover ? 0 : 22) - tspeed) * 0.08;
      if (setW) { tx = (tx + tspeed * dt / 1000) % setW; track.style.transform = "translate3d(" + (-tx).toFixed(2) + "px,0,0)"; }
      traf = requestAnimationFrame(run);
    };
    var tkick = function () { if (ton && !traf && !reduced()) traf = requestAnimationFrame(run); };
    watch(track.parentNode, function (v) { ton = v; tkick(); });
    if (fine) { track.parentNode.addEventListener("mouseenter", function () { thover = true; }); track.parentNode.addEventListener("mouseleave", function () { thover = false; }); }
    var mt = document.getElementById("motion-toggle"); if (mt) mt.addEventListener("click", function () { track.style.transform = ""; tkick(); });
    window.addEventListener("resize", function () { setW = 0; });
  }

  /* titles that shuffle into place */
  var GL = "ABCDEFGHIKLMNOPRSTUVX0123456789/";
  function scramble(el) {
    if (reduced() || el._sc) return; var txt = el.dataset.t || (el.dataset.t = el.textContent), n = 0, total = Math.max(6, Math.min(10, txt.length));
    el._sc = setInterval(function () {
      n++; var cut = Math.floor(txt.length * n / total), out = txt.slice(0, cut);
      for (var i = cut; i < txt.length; i++) out += txt[i] === " " ? " " : GL.charAt(Math.floor(Math.random() * GL.length));
      el.textContent = out; if (n >= total) { clearInterval(el._sc); el._sc = null; el.textContent = txt; }
    }, 28);
  }
  each(".piece", function (p) { var t = p.querySelector("h3 a"); if (t) p.addEventListener("mouseenter", function () { scramble(t); }); });
  each(".also7 a", function (a) { var t = a.querySelector(".t"); if (t) a.addEventListener("mouseenter", function () { scramble(t); }); });
  each(".site-nav a", function (a) { a.addEventListener("mouseenter", function () { scramble(a); }); });
  each(".buy7 h1", function (h) { setTimeout(function () { scramble(h); }, 420); });

  if (fine) {
    /* buttons pull toward the pointer */
    each(".btn:not(.buy-btn), .tool-btn, .back7, .more7 .add", function (b) {
      b.classList.add("mag");
      b.addEventListener("mousemove", function (e) { if (reduced()) return; var r = b.getBoundingClientRect(); b.style.transform = "translate(" + ((e.clientX - r.left - r.width / 2) * 0.22).toFixed(1) + "px," + ((e.clientY - r.top - r.height / 2) * 0.32).toFixed(1) + "px)"; });
      b.addEventListener("mouseleave", function () { b.style.transform = ""; });
    });
  }

  /* hero: live copies of the figure slide with the pointer and the scroll.
     Two see-through cut-outs moved by transform only, added after the page has loaded. */
  var lf = document.querySelector(".hero3 figure"), lhero = document.querySelector(".hero3");
  if (lf && lhero) {
    var addLive = function () {
      var ls = ["live l1", "live l2"].map(function (c) { var k = new Image(); k.className = c; k.alt = ""; k.setAttribute("aria-hidden", "true"); k.decoding = "async"; k.src = LMA("hero-ghost.webp"); lf.appendChild(k); return k; });
      var lpx = 0, lcur = 0, lraf = 0;
      var lstep = function () {
        var target = reduced() ? 0 : lpx * -70 + Math.min(70, window.scrollY * 0.1);
        lcur += (target - lcur) * 0.16;
        var o = Math.min(0.5, Math.abs(lcur) / 55);
        ls[0].style.transform = "translate3d(" + lcur.toFixed(1) + "px,0,0)"; ls[0].style.opacity = o.toFixed(3);
        ls[1].style.transform = "translate3d(" + (lcur * 2.1).toFixed(1) + "px,0,0)"; ls[1].style.opacity = (o * 0.5).toFixed(3);
        lraf = Math.abs(target - lcur) > 0.15 ? requestAnimationFrame(lstep) : 0;
      };
      var lkick = function () { if (!lraf) lraf = requestAnimationFrame(lstep); };
      if (fine) { lhero.addEventListener("mousemove", function (e) { lpx = e.clientX / window.innerWidth - 0.5; lkick(); }, { passive: true }); lhero.addEventListener("mouseleave", function () { lpx = 0; lkick(); }); }
      window.addEventListener("scroll", function () { if (window.scrollY < window.innerHeight * 1.2) lkick(); }, { passive: true });
    };
    if (document.readyState === "complete") setTimeout(addLive, 400); else window.addEventListener("load", function () { setTimeout(addLive, 400); });
  }

  /* the hero logo throws its copies every few seconds */
  var gm = document.querySelector(".hero3 .ghostmark"), heroOn = true;
  if (gm) {
    watch(gm, function (v) { heroOn = v; });
    var jolt = function () {
      if (heroOn && !reduced() && !document.hidden && !gm.classList.contains("building")) {
        gm.style.setProperty("--lag", 2.4); setTimeout(function () { window.dispatchEvent(new Event("scroll")); }, 170);
        var hf = document.querySelector(".hero3 figure"), hi = hf ? hf.querySelector("img") : null;
        if (hi) {
          var hs = ["h1", "h2", "h3"].map(function (c) { var k = hi.cloneNode(false); k.className = "hslice " + c; k.alt = ""; k.removeAttribute("fetchpriority"); k.setAttribute("aria-hidden", "true"); hf.appendChild(k); return k; });
          hf.classList.add("glitch"); setTimeout(function () { hf.classList.remove("glitch"); hs.forEach(function (k) { k.remove(); }); }, 400);
        }
      }
      setTimeout(jolt, 4200 + Math.random() * 3600);
    };
    setTimeout(jolt, 3400);
  }

  /* the "me" mark only drifts while it is on screen */
  var cp = document.getElementById("copies"); if (cp) watch(cp, function (v) { cp.classList.toggle("live", v); });

  /* closing slogan rises line by line */
  var ch = document.querySelector(".creed3 h2");
  if (ch && !reduced() && "IntersectionObserver" in window) {
    ch.innerHTML = ch.innerHTML.split(/<br\s*\/?>/i).map(function (l, i) { return '<span class="rise7" style="--i:' + i + '"><span>' + l + "</span></span>"; }).join("");
    ch.classList.add("rz7");
    var cio = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { ch.classList.add("in"); cio.disconnect(); } }, { threshold: 0.4 }); cio.observe(ch);
  }

  /* the next pages load in the background, so a page change opens at once */
  var warm = function () {
    var seen = {}; each("a[data-lm]", function (a) { var h = a.getAttribute("href"); if (seen[h] || !LMRE.test(h)) return; seen[h] = 1; var l = document.createElement("link"); l.rel = "prefetch"; l.href = h; document.head.appendChild(l); });
  };
  if ("requestIdleCallback" in window) requestIdleCallback(warm, { timeout: 2500 }); else setTimeout(warm, 1500);
})();


/* ---------- Shopify bag: add to bag, header count, bag page ---------- */
(function () {
  if (!window.LM || !window.LM.routes) return;
  var R = window.LM.routes;
  function each(sel, fn, root) { Array.prototype.forEach.call((root || document).querySelectorAll(sel), fn); }
  var toast = document.createElement("div"); toast.className = "toast7"; toast.setAttribute("role", "status");
  toast.innerHTML = '<span>Added to bag</span><a href="' + R.cart + '">View bag</a>'; document.body.appendChild(toast); var tt;
  function setCount(n) { each("[data-cart-count]", function (el) { el.textContent = n; el.classList.remove("bump"); void el.offsetWidth; el.classList.add("bump"); }); }
  function post(url, body) { return fetch(url, { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify(body) }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }); }

  document.addEventListener("submit", function (e) {
    var f = e.target; if (!f.matches || !f.matches("form[data-lm-add]")) return;
    e.preventDefault();
    var picked = f.querySelector('input[name="id"]:checked') || f.querySelector('input[name="id"][type="hidden"]');
    var hint = f.querySelector("[data-hint]"), btn = f.querySelector("button[type=submit]"), field = f.querySelector(".size7");
    if (!picked) { if (field) field.classList.add("nudge"); if (hint) hint.textContent = "Pick a size first."; return; }
    var label = btn.textContent; btn.disabled = true;
    post(R.add, { id: +picked.value, quantity: 1 }).then(function (res) {
      if (!res.ok) { if (hint) { hint.textContent = res.j.description || res.j.message || "Could not add this piece."; hint.classList.add("lm-err"); } btn.disabled = false; return; }
      btn.textContent = "Added ✓";
      return fetch(R.cart + ".js", { credentials: "same-origin", headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); }).then(function (c) {
        setCount(c.item_count); toast.classList.add("on"); clearTimeout(tt); tt = setTimeout(function () { toast.classList.remove("on"); }, 3200);
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1100);
      });
    }).catch(function () { f.removeAttribute("data-lm-add"); f.submit(); });
  });
  document.addEventListener("change", function (e) {
    if (!e.target.matches || !e.target.matches('.size7 input[name="id"]')) return;
    var f = e.target.closest("form"), hint = f && f.querySelector("[data-hint]"); if (hint) { hint.classList.remove("lm-err"); hint.textContent = "Size " + e.target.dataset.title + " selected"; }
    var field = e.target.closest(".size7"); if (field) field.classList.remove("nudge");
  });

  /* bag page: change a quantity or remove a line, then redraw the bag from the server */
  document.addEventListener("click", function (e) {
    var b = e.target.closest ? e.target.closest("[data-lm-line]") : null; if (!b) return;
    var root = document.querySelector("[data-lm-cart]"); if (!root) return;
    e.preventDefault(); var li = b.closest(".line7"), q = +b.dataset.qty;
    if (q === 0 && li) { li.style.maxHeight = li.offsetHeight + "px"; void li.offsetWidth; li.classList.add("gone"); }
    root.setAttribute("aria-busy", "true");
    post(R.change, { id: b.dataset.lmLine, quantity: q }).then(function (res) {
      if (!res.ok) { window.location.reload(); return; }
      setCount(res.j.item_count);
      return fetch(window.location.pathname + "?section_id=" + root.dataset.lmCart, { credentials: "same-origin" }).then(function (r) { return r.text(); }).then(function (html) {
        var d = document.createElement("div"); d.innerHTML = html; var fresh = d.querySelector("[data-lm-cart]");
        if (fresh) root.innerHTML = fresh.innerHTML; root.removeAttribute("aria-busy");
      });
    }).catch(function () { window.location.reload(); });
  });
})();
